import i from"styled-components";import{theme as r}from"../../../theme.js";const n=i.span`
  width: fit-content;
  font-size: 12px;
  line-height: 14px;
  color: ${({color:o})=>o};
  background-color: ${({backgroundColor:o})=>o};
  border-radius: ${r.radius}px;
  padding: ${r.spacing}px ${r.spacing*2}px;
  display: block;
`;export{n as Container};
